import React, { useEffect, useMemo } from 'react';
import { Container } from 'components/Container';
import { Header } from 'sections/Header';
import { ScrollRestoration, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

export const Layout = ({ children }: { children: React.ReactNode}) => {
    const location = useLocation();
    const openSupportForm = () => {
        window.parent.postMessage('callContactSupport', '*');
    };
    const navigate = useNavigate();

    useEffect(() => {
        const handleHashChange = () => {
            if (window.location.hash === '#supportForm') {
                navigate('/');
                openSupportForm();
            }
        };

        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [location]);
    const theme = useTheme();
    const mainSx = useMemo(() => ({
        '& a': {
            color: theme.palette.primary.main,
        },
    }), [theme]);

    return (
        <Box sx={mainSx}>
            <ScrollRestoration />
            <Header />
            <Container>
                {children}
            </Container>
        </Box>
    );
};
